__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-ads-demand/v3_2_3/";